import { Game } from '@statsbomb/parachute-types';
import { GamesBySeason } from '@/types/filters';

export const formatGameTimestamp = (minute: number, second: number) =>
  // Ensure mins/secs are two characters long - if not prefix with a zero (e.g 2 mins becomes 02)
  `${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;

export const getFormattedGameName = (game: Game) => `${game.name}, ${game.date}`;

export const toGameSelectorGroups = (gamesBySeason: GamesBySeason[]) =>
  gamesBySeason.map(season => ({
    seasonId: season.seasonId,
    seasonName: season.seasonName,
    games: season.games.map(({ game }) => ({
      game: {
        gameId: game.gameId,
        name: game.name ?? '',
        date: game.date ?? undefined,
        competitionName: game.competitionName,
      },
    })),
  }));
